import React, { useState } from "react";
import {
  Dimensions,
  SafeAreaView,
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Image,
  ScrollView,
} from "react-native";
import AppImages from "../../Constants/AppImages";
import AppColors from "../../Constants/AppColors";
import All from "./TopTab/All";
import Online from "./TopTab/Online";
import Offline from "./TopTab/Offline";
import Untracked from "./TopTab/Untracked";
import AppFonts from "../../Constants/AppFonts";
import AllVehicleCategory from "./VehicleCategory/TopTabVehicleCategory/AllVehicleCategory";
// import { useTranslation } from "react-i18next";
// import MainVehicleGroup from "./VehicleGroup.js/MainVehicleGroup";
// import MainHardware from "./HardwareFeatureset/MainHardware";
import Appstyles from "../../Constants/AppStyles";

const { width, height } = Dimensions.get("window");

// Custom Tab Component
// Custom Tab Component (with defensive checks)
const CustomTabBar = ({
  state,
  descriptors,
  navigation,
  activeTintColor,
  inactiveTintColor,
}) => {
  return (
    <View style={styles.tabBarContainer}>
      {state.routes.map((route, index) => {
        // Add defensive checks
        const descriptor = descriptors[route.key];
        if (!descriptor) return null; // or handle gracefully

        const { options } = descriptor;
        const label = options?.tabBarLabel || options?.title || route.name;
        const isFocused = state.index === index;

        const onPress = () => {
          const event = navigation.emit({
            type: "tabPress",
            target: route.key,
            canPreventDefault: true,
          });

          if (!isFocused && !event.defaultPrevented) {
            navigation.navigate(route.name);
          }
        };

        return (
          <TouchableOpacity
            key={route.key}
            accessibilityRole="button"
            accessibilityState={isFocused ? { selected: true } : {}}
            accessibilityLabel={options?.tabBarAccessibilityLabel}
            testID={options?.tabBarTestID}
            onPress={onPress}
            style={[styles.tabButton, isFocused && styles.activeTabButton]}
          >
            <Text
              style={[
                styles.tabLabel,
                { color: isFocused ? activeTintColor : inactiveTintColor },
              ]}
            >
              {label}
            </Text>
            {isFocused && <View style={styles.activeIndicator} />}
          </TouchableOpacity>
        );
      })}
    </View>
  );
};
const handlePress = () => {
  if (typeof window !== "undefined" && window.history.length > 1) {
    window.history.back();
  } else {
    // Fallback to home or custom action
    window.location.href = "/";
  }
};

// Custom Tab Navigator Component
const CustomTabNavigator = ({
  tabs,
  initialRouteName,
  tabBarProps = {},
  screenProps = {},
}) => {
  const [activeTab, setActiveTab] = useState(
    tabs.findIndex((tab) => tab.name === initialRouteName) || 0
  );

  const activeTintColor = tabBarProps.activeTintColor || "#8F4300";
  const inactiveTintColor = tabBarProps.inactiveTintColor || "#9C4900CC";

  return (
    <View style={{ flex: 1 }}>
      <CustomTabBar
        state={{ routes: tabs, index: activeTab }}
        descriptors={tabs.reduce((acc, tab, index) => {
          acc[tab.name] = {
            options: { tabBarLabel: tab.label || tab.name },
            navigation: { emit: () => {} },
          };
          return acc;
        }, {})}
        navigation={{
          navigate: (name) => {
            const index = tabs.findIndex((tab) => tab.name === name);
            setActiveTab(index);
          },
          emit: () => {},
        }}
        activeTintColor={activeTintColor}
        inactiveTintColor={inactiveTintColor}
      />
      <View style={{ flex: 1 }}>
        {tabs.map(
          (tab, index) =>
            index === activeTab && (
              <View key={tab.name} style={{ flex: 1 }}>
                {tab.component &&
                  React.createElement(tab.component, screenProps)}
              </View>
            )
        )}
      </View>
    </View>
  );
};

const Vehicle = ({ navigation }) => {
  // const { t } = useTranslation(["common"]);
  const [selectedBox, setSelectedBox] = useState(0);
  const [selectedButtonIndex, setSelectedButtonIndex] = useState(0);

  const handleButtonPress = (index) => {
    setSelectedButtonIndex(index);
  };

  // Define tabs for each section
  const vehicleTabs = [
    { name: "All", label: "All", component: All }, // Replace with your actual components
    { name: "Online", label: "Online", component: Online },
    { name: "Offline", label: "Offline", component: Offline },
    { name: "Untracked", label: "Never Tracked", component: Untracked },
  ];

  const categoryTabs = [
    { name: "All", label: "All", component: AllVehicleCategory }, // Replace with your actual component
    {
      name: "VehicleCategory",
      label: "Vehicle Category",
      component: AllVehicleCategory,
    },
  ];

  return (
    <SafeAreaView style={Appstyles.safe}>
      {/* Header based on selected tab */}
      {selectedButtonIndex === 0 ? (
        <View style={Appstyles.HeaderMain}>
          <View style={Appstyles.HeaderSec}>
            <TouchableOpacity
              style={Appstyles.Arrowstyle}
              onPress={handlePress}
            >
              <Image
                source={AppImages.Backbtn}
                style={Appstyles.ArrowImage}
                resizeMode="contain"
              />
            </TouchableOpacity>
            <Text style={Appstyles.HeaderText}>Vehicle</Text>
          </View>
          <View style={Appstyles.rc}>
            <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
              <Image
                source={AppImages.Bellnoti}
                style={Appstyles.BellImage}
                resizeMode="contain"
              />
            </TouchableOpacity>
            <TouchableOpacity onPress={() => navigation.navigate("AddVehicle")}>
              <Image
                source={AppImages.Plus}
                style={Appstyles.PlusImage7}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>
        </View>
      ) : selectedButtonIndex === 1 ? (
        <View style={Appstyles.HeaderMain}>
          <View style={Appstyles.HeaderSec}>
            <TouchableOpacity
              style={Appstyles.Arrowstyle}
              onPress={handlePress}
            >
              <Image
                source={AppImages.Backbtn}
                style={Appstyles.ArrowImage}
                resizeMode="contain"
              />
            </TouchableOpacity>
            <Text style={Appstyles.HeaderText}>Vehicle Category</Text>
          </View>
          <View style={Appstyles.rc}>
            <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
              <Image
                source={AppImages.Bellnoti}
                style={Appstyles.BellImage}
                resizeMode="contain"
              />
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => navigation.navigate("AddvehicleCategory")}
            >
              <Image
                source={AppImages.Plus}
                style={Appstyles.PlusImage}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>
        </View>
      ) : selectedButtonIndex === 2 ? (
        <View style={Appstyles.HeaderMain}>
          <View style={Appstyles.HeaderSec}>
            <TouchableOpacity
              style={Appstyles.Arrowstyle}
              onPress={handlePress}
            >
              <Image
                source={AppImages.Backbtn}
                style={Appstyles.ArrowImage}
                resizeMode="contain"
              />
            </TouchableOpacity>
            <Text style={Appstyles.HeaderText}>Vehicle Group</Text>
          </View>
          <View style={Appstyles.rc}>
            <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
              <Image
                source={AppImages.Bellnoti}
                style={Appstyles.BellImage}
                resizeMode="contain"
              />
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => navigation.navigate("VehicleGroupGeofence")}
            >
              <Image
                source={AppImages.Plus}
                style={Appstyles.PlusImage}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>
        </View>
      ) : selectedButtonIndex === 4 ? (
        <View style={Appstyles.HeaderMain}>
          <View style={Appstyles.HeaderSec}>
            <TouchableOpacity
              style={Appstyles.Arrowstyle}
              onPress={handlePress}
            >
              <Image
                source={AppImages.Backbtn}
                style={Appstyles.ArrowImage}
                resizeMode="contain"
              />
            </TouchableOpacity>
            <Text style={Appstyles.HeaderText}>Vehicle Hardware</Text>
          </View>
          <View style={Appstyles.rc}>
            <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
              <Image
                source={AppImages.Bellnoti}
                style={Appstyles.BellImage}
                resizeMode="contain"
              />
            </TouchableOpacity>
            <TouchableOpacity onPress={() => navigation.navigate("AddSync")}>
              <Image
                source={AppImages.Plus}
                style={Appstyles.PlusImage7}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>
        </View>
      ) : null}

      {/* Main horizontal tab selector */}
      <ScrollView
        horizontal
        contentContainerStyle={Appstyles.scrollVehicle7}
        showsHorizontalScrollIndicator={false}
      >
        <View style={Appstyles.MainContainervehicle7}>
          {[
            { index: 0, label: "Vehicle" },
            { index: 1, label: "Vehicle Category" },
            { index: 2, label: "Vehicle Group" },
            { index: 4, label: "Hardware Feature-Set" },
          ].map((item) => (
            <TouchableOpacity
              key={item.index}
              onPress={() => handleButtonPress(item.index)}
              style={[
                Appstyles.VehicleSelectorveh7,
                {
                  backgroundColor:
                    selectedButtonIndex === item.index
                      ? AppColors.brown
                      : AppColors.white,
                },
              ]}
            >
              <Text
                style={[
                  Appstyles.VehicleSelectorTextVeh7,
                  {
                    color:
                      selectedButtonIndex === item.index
                        ? AppColors.white
                        : AppColors.C4900CC,
                  },
                ]}
              >
                {item.label}
              </Text>
            </TouchableOpacity>
          ))}
        </View>
      </ScrollView>

      {/* Content area with custom tab navigation */}
      <View style={styles.contentContainer}>
        {selectedButtonIndex === 0 && (
          <CustomTabNavigator
            tabs={vehicleTabs}
            initialRouteName="All"
            tabBarProps={{
              activeTintColor: "#8F4300",
              inactiveTintColor: "#9C4900CC",
            }}
          />
        )}

        {selectedButtonIndex === 1 && (
          <CustomTabNavigator
            tabs={categoryTabs}
            initialRouteName="All"
            tabBarProps={{
              activeTintColor: "#8F4300",
              inactiveTintColor: "#9C4900CC",
            }}
          />
        )}

        {selectedButtonIndex === 2 && (
          <View style={{ flex: 1, backgroundColor: "red" }}>
            {/* <MainVehicleGroup /> */}
            <Text style={styles.placeholderText}>Vehicle Group Component</Text>
          </View>
        )}

        {selectedButtonIndex === 4 && (
          <View style={{ flex: 1 }}>
            {/* <MainHardware /> */}
            <Text style={styles.placeholderText}>Hardware Component</Text>
          </View>
        )}
      </View>
    </SafeAreaView>
  );
};

export default Vehicle;

const styles = StyleSheet.create({
  safe: {
    flex: 1,
    backgroundColor: "#F6EFE9",
  },
  contentContainer: {
    flex: 1,
    backgroundColor: "white",
  },
  // Custom Tab Bar Styles
  tabBarContainer: {
    flexDirection: "row",
    backgroundColor: "white",
    paddingHorizontal: 10,
    paddingTop: 10,
  },
  tabButton: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 12,
    marginHorizontal: 4,
    position: "relative",
  },
  activeTabButton: {
    // Additional active styles if needed
  },
  tabLabel: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    textTransform: "none",
  },
  activeIndicator: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: 3,
    backgroundColor: AppColors.brown,
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
  },
  placeholderText: {
    textAlign: "center",
    marginTop: 50,
    fontSize: 16,
    color: AppColors.brown1,
  },
});
